module.exports = __webpack_public_path__ + "img/img04.f95dd021.png";